var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",attrs:{"id":"particles","playsinline":"","preload":"","muted":""},domProps:{"muted":true},on:{"ended":_vm.onVideoEnd}},[_c('source',{attrs:{"type":"video/mp4","src":"/videos/wave.mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }